<template>
  <div>
    <h2>
      <span class="step-name">
        Animal Numbers - Deer
      </span>
      <comments field-name='heading_animal_numbers_deer'></comments>
    </h2>
    <h3>Animal numbers are numbers wintered or expected to be wintered for the consult year</h3>

    <div class="step-section" v-for="gf_animal in enabledAnimals('deer', false)" :key="'deer_'+gf_animal.id">
      <h3> {{ gf_animal.name }} </h3>

      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <text-area label="Animal Notes from Ezyvet" :field-name="`animal_${gf_animal.id}-notes`" disabled>
          </text-area>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <h3>Previous Consult</h3>

          <div class="form-group input-box">
            <label>MA Hinds</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-ma_hinds`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>R2 Hinds</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-r2_hinds`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>R1 Hinds</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-r1_hinds`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Hinds Breed</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-hinds_breed`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>MA Stags</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-ma_stags`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>R2 Stags</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-r2_stags`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Spikers</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-r1_stags`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Stags Breed</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-stags_breed`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Deer Venison?</label>
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_deer_venison`] == true" disabled>Yes
              </label>
              <label class="radio-inline">
                <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_deer_venison`] == false" disabled>No
              </label>
            </div>
          </div>

          <div class="form-group input-box">
            <label>Deer Velvet?</label>
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_deer_velvet`] == true" disabled>Yes
              </label>
              <label class="radio-inline">
                <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_deer_velvet`] == false" disabled>No
              </label>
            </div>
          </div>

          <div class="form-group input-box">
            <label>Stud Breeder?</label>
            <div class="radio">
              <label class="radio-inline">
                <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_deer_stud_breeder`] == true" disabled>Yes
              </label>
              <label class="radio-inline">
                <input type="radio" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_deer_stud_breeder`] == false" disabled>No
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <h3>This Year</h3>

          <number-input :field-name="`animal_${gf_animal.id}-ma_hinds`"
                        label="MA Hinds">
          </number-input>

          <number-input :field-name="`animal_${gf_animal.id}-r2_hinds`"
                        label="R2 Hinds">
          </number-input>

          <number-input :field-name="`animal_${gf_animal.id}-r1_hinds`"
                        label="R1 Hinds">
          </number-input>

          <text-input :field-name="`animal_${gf_animal.id}-hinds_breed`"
                        label="Hinds Breed"
                        >
          </text-input>

          <number-input :field-name="`animal_${gf_animal.id}-ma_stags`"
                        label="MA Stags">
          </number-input>

          <number-input :field-name="`animal_${gf_animal.id}-r2_stags`"
                        label="R2 Stags">
          </number-input>

          <number-input :field-name="`animal_${gf_animal.id}-r1_stags`"
                        label="Spikers">
          </number-input>

          <text-input :field-name="`animal_${gf_animal.id}-stags_breed`"
                        label="Stags Breed">
          </text-input>

          <radio-input label="Deer Venison?"
                       :field-name="`animal_${gf_animal.id}-is_deer_venison`"
                       :choices="[
                         {value: true, display: 'Yes'},
                         {value: false, display: 'No'},
                       ]">
          </radio-input>

          <radio-input label="Deer Velvet?" 
                       :field-name="`animal_${gf_animal.id}-is_deer_velvet`"
                       :choices="[
                         {value: true, display: 'Yes'},
                         {value: false, display: 'No'},
                       ]">
          </radio-input>

          <radio-input label="Stud Breeder?" 
                       :field-name="`animal_${gf_animal.id}-is_deer_stud_breeder`"
                       :choices="[
                         {value: true, display: 'Yes'},
                         {value: false, display: 'No'},
                       ]">
          </radio-input>
        </div>
      </div>
    </div>
    <div class="step-section" v-for="gf_animal in newAnimals('deer')" :key="'deer_'+gf_animal.frontend_id">
      <h3> {{ gf_animal.name }} - (Newly created) </h3>

      <div class="row">

        <div class="col-md-6">
          <h3>This Year</h3>

          <number-input :field-name="`new_animal_${gf_animal.frontend_id}-ma_hinds`"
                        label="MA Hinds">
          </number-input>

          <number-input :field-name="`new_animal_${gf_animal.frontend_id}-r2_hinds`"
                        label="R2 Hinds">
          </number-input>

          <number-input :field-name="`new_animal_${gf_animal.frontend_id}-r1_hinds`"
                        label="R1 Hinds">
          </number-input>

          <text-input :field-name="`new_animal_${gf_animal.frontend_id}-hinds_breed`"
                        label="Hinds Breed">
          </text-input>

          <number-input :field-name="`new_animal_${gf_animal.frontend_id}-ma_stags`"
                        label="MA Stags">
          </number-input>

          <number-input :field-name="`new_animal_${gf_animal.frontend_id}-r2_stags`"
                        label="R2 Stags">
          </number-input>

          <number-input :field-name="`new_animal_${gf_animal.frontend_id}-r1_stags`"
                        label="Spikers">
          </number-input>

          <text-input :field-name="`new_animal_${gf_animal.frontend_id}-stags_breed`"
                        label="Stags Breed">
          </text-input>

          <radio-input label="Deer Venison?"
                       :field-name="`new_animal_${gf_animal.frontend_id}-is_deer_venison`"
                       :choices="[
                         {value: true, display: 'Yes'},
                         {value: false, display: 'No'},
                       ]">
          </radio-input>

          <radio-input label="Deer Velvet?" 
                       :field-name="`new_animal_${gf_animal.frontend_id}-is_deer_velvet`"
                       :choices="[
                         {value: true, display: 'Yes'},
                         {value: false, display: 'No'},
                       ]">
          </radio-input>

          <radio-input label="Stud Breeder?" 
            :field-name="`new_animal_${gf_animal.frontend_id}-is_deer_stud_breeder`"
            :choices="[
              {value: true, display: 'Yes'},
              {value: false, display: 'No'},
            ]">
          </radio-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapGetters } from 'vuex'

export default {
  name: 'AnimalNumbersDeer',
  mixins: [ baseComponent ],
  computed:
  {
    ...mapGetters('currentConsult', ['enabledAnimals', 'newAnimals']),
  }
};
</script>
